import { createSelector } from 'reselect'
import entities from 'entities'

const selectDevicebits = state => state.devicebits
const selectDevices = state => state.devices.devices
const selectRouting = state => state.routing

const selectStyles = createSelector(
  selectDevicebits,
  devicebits => devicebits.styles
)

const selectCurrentPhoneId = createSelector(
  selectDevicebits,
  devicebits => devicebits.currentPhoneId
)

const selectPreSaleFlag = createSelector(
  selectDevicebits,
  devicebits => devicebits.preSaleFlag
)

const selectLanguage = createSelector(
  selectDevicebits,
  devicebits => devicebits.language
)

const selectPhoneName = createSelector(
  selectDevicebits,
  devicebits => devicebits.currentPhoneName
)

const selectCurrentPhone = createSelector(
  selectCurrentPhoneId,
  selectDevices,
  (phoneId, deviceList) => {
    let device = deviceList.find(
      device => parseInt(device.id, 10) === parseInt(phoneId, 10)
    )
    if (device)
      return {
        ...device,
        name_pretty: `${device.manufacturer} ${
          device.vanity_name
            ? entities.decodeHTML(device.vanity_name) + ' (' + device.name + ')'
            : device.name
        }`
      }
  }
)

const selectRoutingKey = createSelector(
  selectRouting,
  routing => routing.locationBeforeTransitions.key
)

const selectCustomer = createSelector(
  selectDevicebits,
  devicebits => devicebits.customer
)

const selectQuery = createSelector(
  selectRouting,
  routing => routing.locationBeforeTransitions.query
)

const selectOptions = createSelector(
  selectDevicebits,
  state => state.options
)

export {
  selectStyles,
  selectCurrentPhoneId,
  selectCurrentPhone,
  selectPreSaleFlag,
  selectPhoneName,
  selectLanguage,
  selectRoutingKey,
  selectCustomer,
  selectQuery,
  selectOptions
}



// WEBPACK FOOTER //
// ./src/containers/App/selectors.js